module.exports = __webpack_public_path__ + "img/cleaning.0aaeb5b0.jpg";